{
  "nav": {
    "pricing": "Priser",
    "contact": "Kontakt",
    "menu": "Meny",
    "login": "Logg inn",
    "features": "Funksjoner",
    "brandHomeAria": "Done-it — hjem",
    "market": {
      "belgium": "Belgia",
      "international": "Verden over"
    }
  },
  "footer": {
    "tagline": "Done-it — Enkel tidsregistrering.",
    "terms": "Vilkår",
    "privacy": "Personvern",
    "contact": "Kontakt"
  },
  "help": "Trenger du hjelp?",
  "continue": "Fortsett",
  "back": "Tilbake",
  "change": "Endre",
  "retry": "Prøv igjen",
  "errors": {
    "unexpected": "Uventet feil"
  },
  "step": {
    "of": "Steg {{n}} av {{total}}"
  },
  "funnel": {
    "title": "Abonnement · Done-it"
  }
}
